const TRANSFERENCE_CONFIG_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
};

module.exports = {
  TRANSFERENCE_CONFIG_STATUS,
};
